"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketController = void 0;
var websocket_1 = require("websocket");
var constants_1 = require("../../constants");
/**
 * Websocket controller extends window.WebSocket
 */
var SocketController = /** @class */ (function (_super) {
    __extends(SocketController, _super);
    /**
     * WebSocket contructor
     * @param type - socket type (transaction, portfolio, or price)
     * @param onopen - onopen callback
     * @param onclose - onclose callback
     * @param onmessage - onmessage callback
     */
    function SocketController(type, onopen, onclose, onmessage) {
        var _this = this;
        switch (type) {
            case 'transaction':
                _this = _super.call(this, constants_1.WSS_TRANSACTION) || this;
                break;
            case 'portfolio':
                _this = _super.call(this, constants_1.WSS_PORTFOLIO) || this;
                break;
            case 'price':
                _this = _super.call(this, constants_1.WSS_PRICE) || this;
                break;
            default:
                throw new Error('Must include a valid websocket type');
        }
        _this.onopen = onopen;
        _this.onclose = onclose;
        _this.onmessage = onmessage;
        return _this;
    }
    return SocketController;
}(websocket_1.w3cwebsocket));
exports.SocketController = SocketController;
